import useMount from '@src/utils/hooks/use-mount';
import { observable, computed } from 'mobx';
import { noop } from '@src/utils/common-util';
class MechaPosterStore {
  constructor(props = {}) {
    Object.assign(this, { ...props });
  }

  @observable isActive = false;
  // 打开弹窗
  @observable openMechaInfo = noop;

  // 机甲武装信息
  @computed
  get mechaMsg() {
    return this.mechaStore?.mechaInfoMsg;
  }

  use() {
    useMount(() => {});
  }
}

export default MechaPosterStore;
